import { render, staticRenderFns } from "./AddCustomerDialog.vue?vue&type=template&id=70378b42&scoped=true"
import script from "./AddCustomerDialog.vue?vue&type=script&lang=js"
export * from "./AddCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70378b42",
  null
  
)

export default component.exports